import LRU from '../../utils/lrucache/lrucache';

var ImpressionObserver = /*#__PURE__*/function () {
  function ImpressionObserver(size, hasher) {
    this.cache = new LRU(size);
    this.hasher = hasher;
  }

  var _proto = ImpressionObserver.prototype;

  _proto.testAndSet = function testAndSet(impression) {
    if (!impression) return null;
    var hash = this.hasher(impression);
    var previous = this.cache.get(hash);
    this.cache.set(hash, impression.time);
    return previous;
  };

  return ImpressionObserver;
}();

export default ImpressionObserver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/impressions/observer/observer.js
// module id = 2829
// module chunks = 39